import { getPriorityTemplateListApi, queryTemplatesApi } from "@/apis"
import { TemplateData } from "@shared/types"
import { makeAutoObservable, reaction, toJS } from "mobx"
import { message } from "antd/lib"
import debounce from "lodash/debounce";
import { Classification } from "@shared/constants";

export class TemplateStore {
  templateList: TemplateData[] = []
  priorityTemplateMap: Map<Classification, TemplateData[]> = new Map()

  loading: boolean = false
  requestSeq: number = 0
  searchFilter: { 
    keyword?: string, 
    classify?: number,
    templateType?: number,
    ecommerceFestival?: number,
    holidayTheme?: number,
    industryCategory?: number,
    scenarioUsage?: number,
  } = {}
  hasMore: boolean = true // 添加hasMore状态

  rootStore

  constructor(rootStore) {
    makeAutoObservable(this, {
      rootStore: false
    })
    this.fetchTemplateList = debounce(this.fetchTemplateList, 300)
    this.rootStore = rootStore
  }

  setSearchKeyword(value: string) {
    this.searchFilter.keyword = value
  }
  setClassify(value?: number) {
    this.searchFilter.classify = value
  }
  beginNewSearch() {
    this.requestSeq++
    this.templateList = []
    this.hasMore = true
    this.loading = true
  }
  setTemplateType(value?: number) {
    this.searchFilter.templateType = value
  }
  setEcommerceFestival(value?: number) {
    this.searchFilter.ecommerceFestival = value
  }
  setHolidayTheme(value?: number) {
    this.searchFilter.holidayTheme = value
  }
  setIndustryCategory(value?: number) {
    this.searchFilter.industryCategory = value
  }
  setScenarioUsage(value?: number) {
    this.searchFilter.scenarioUsage = value
  }

  resetSearch() {
    this.searchFilter = {}
    this.templateList = []
    this.hasMore = true // 重置hasMore状态
  }

  // 修改fetchTemplateList支持追加加载
  async fetchTemplateList(append = false, page = 1, pageSize = 50) {
    this.loading = true
    const seq = this.requestSeq

    try {
      const res = await queryTemplatesApi({
        keyword: this.searchFilter.keyword,
        classify: this.searchFilter.classify,
        page,
        pageSize,
        templateType: this.searchFilter.templateType,
        ecommerceFestival: this.searchFilter.ecommerceFestival,
        holidayTheme: this.searchFilter.holidayTheme,
        industryCategory: this.searchFilter.industryCategory,
        scenarioUsage: this.searchFilter.scenarioUsage,
      })
      const { code, data } = res
      if (code !== 0) {
        return message.error('获取模版列表失败')
      }
      const list = data?.list?.map(item => {
        return {
          ...item,
        }
      })
      if (seq !== this.requestSeq) {
        return
      }
      
      if (append) {
        this.templateList = [...this.templateList, ...(list || [])]
      } else {
        this.templateList = list || []
      }
      
      // 判断是否还有更多数据
      this.hasMore = (list?.length || 0) === pageSize
    } catch (error) {
      console.error(error)
      message.error('获取模版列表失败')
    } finally {
      this.loading = false
    }
  }

  // 添加加载更多方法
  async fetchMoreTemplateList(page: number, pageSize: number = 20) {
    if (!this.hasMore || this.loading) return
    await this.fetchTemplateList(true, page, pageSize)
  }

  async fetchPriorityTemplateList() {
    this.loading = true
    try {
      const res = await getPriorityTemplateListApi()
      const { code, data } = res
      if (code !== 0) {
        return message.error('获取优先模版列表失败')
      }
      const list = data?.list?.map(item => {
        return {
          ...item,
        }
      }) || []
      this.priorityTemplateMap.clear()
      list.forEach(item => {
        const classify = item.classify as Classification
        if (!this.priorityTemplateMap.has(classify)) {
          this.priorityTemplateMap.set(classify, [])
        }
        this.priorityTemplateMap.get(classify)?.push(item)
      })
    } catch (error) {
      console.error(error)
      message.error('获取优先模版列表失败')
    } finally {
      this.loading = false
    }
  }
}